import moment from "moment";
import {EventsTypes} from "@/enums/EventsTypes";
import firebase from "firebase/app";
import {ResidentStatus} from "@/enums/ResidentStatus";
import {CalendarScreenTypeEnum} from "@/enums/CalendarScreenTypeEnum";
import {PremiumServiceEventTypes} from "@/enums/PremiumServiceEventTypes";
import ConfirmDlg from "@/components/popup/confirm-dialog/ConfirmDlg.vue";
import EditRecurringEventDialog from "@/views/calender/view-calendar-item/EditRecurringEventDialog.vue";
import {EditRecurringEventTypes} from "@/enums/EditRecurringEventTypes";
import {CalendarTimeFormatMixin} from "@/mixins/CalendarTimeFormat";

export default {
    name: "EventPreviewCard",
    components: {EditRecurringEventDialog, ConfirmDlg},
    mixins: [CalendarTimeFormatMixin],
    data() {
        return {
            editRecurringEventType: null,
            isOpenEditRecurringEventOptionsDialog: false,
            currentCalenderSceenType: null,
            selectedElement: null,
            selectedEvent: null,
            endRecurringDate: null,
            selectedOpen: false,
            detailsList: [],
            day: "",
            filters: [
                EventsTypes.ConciergeRequest,
                EventsTypes.LifestylePrograms,
                EventsTypes.PremiumServices,
            ],
            invitedResidents: 0,
            loadingInvitedResidents: false,
            eventType: ""
        }
    },
    props:{
        redirectPage: String
    },
    computed: {
        facility() {
            return this.$store.state.facilityModule.selectedFacility;
        },
        eventTypes() {
            return EventsTypes;
        },
        calendarRecurringEvents() {
            return this.$store.state.calenderModule.currentCalenderRecurringEvents;
        },
        currentFacility() {
            return this.$store.state.authModule.currentFacility;
        },
        isConciergeEvent() {
            return this.selectedEvent.type === EventsTypes.PremiumServices;
        }
    },
    methods: {
        open(selectedElement: any, selectedEvent: any, currentCalenderSceenType: CalendarScreenTypeEnum) {
            this.selectedElement = selectedElement;
            this.currentCalenderSceenType = currentCalenderSceenType;
            this.selectedEvent = selectedEvent ?? null;
            this.day = moment(this.selectedEvent).format("YYYY-MM-DD")
            this.checkEventType();
            this.checkInvitedResidents();
            requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true));
            this.$store.dispatch('getCalenderRecurringEvents', selectedEvent.id);
        },
        close() {
            this.selectedElement = null;
            this.selectedEvent = null;
            this.selectedOpen = false
        },
        openEvent() {
            if (this.selectedEvent?.isRecurring) {
                this.selectedEventId = this.selectedEvent.id;

                this.$router.push("/calendar/" + this.selectedEventId);
            } else {

                this.$store.dispatch("setMainCalendarFilters", {screenType: this.currentCalenderSceenType});

                if(this.redirectPage === 'bookings-and-orders') {
                    this.$router.push("/bookings-and-orders/" + this.selectedEvent.conciergeRequestId);
                    return
                }

                const isVideoCallEnabled: any = this.filters.includes(this.eventTypes.RealtimeCall);
                this.$router.push({ name: 'ViewCalendarEvent', params: { id: this.selectedEvent.id, isVideoCallEnabled: isVideoCallEnabled }});

            }
        },
        openConciergeService() {
            this.$router.push("/concierge-service/" + this.selectedEvent.invitees[0]);
        },
        editEvent() {
            this.$router.push({
                name: 'ViewCalendarEvent',
                params: {
                    id: this.selectedEvent.id,
                    isEditEvent: true,
                },
            });
        },
        deleteEvent() {
            this.selectedOpen = false;
            if (this.selectedEvent?.isRecurring) {
                this.openEditRecurringEventOptionsDialog()
            } else {
                this.deleteSingleEvent();
            }
        },

        openEditRecurringEventOptionsDialog() {
            this.isOpenEditRecurringEventOptionsDialog = true;
            this.$refs.editRecurringEventDialog?.changeTitle({isDelete: this.isDeleteRecurring});
        },

        async deleteSingleEvent() {
            await this.$refs.confirmationModal
                .open(null, this.$i18n.messages[this.$i18n.locale]['ViewCalendarItem.DeleteEventMessage'], false)
                .then(async (response: { agree: any }) => {
                    if (response && response.agree) {
                        const start = moment(this.selectedEvent.startDate).add(-1, "month").toDate();
                        const end = moment(this.selectedEvent.endDate).add(1, "month").toDate();
                        await this.$store.dispatch('deleteCalenderEvent', { id: this.selectedEvent.id, isRecurring: this.selectedEvent?.isRecurring, office365EventId: this.selectedEvent?.office365EventId, range: {start, end}})
                    }
                });
        },

        closeEvent() {
            this.selectedOpen = false;
        },
        checkEventType() {
            const type = this.selectedEvent.type;
            switch (type) {
                case EventsTypes.LifestylePrograms:
                    this.eventType = this.$t("EventsTypesOptions.LifestylePrograms");
                    break;
                case EventsTypes.PremiumServices:
                    this.eventType = this.$t("EventsTypesOptions.PremiumServices");
                    break;
                case EventsTypes.ConciergeRequest:
                    this.eventType = this.$t("EventsTypesOptions.ConciergeRequest");
                    break;
                case EventsTypes.ScheduledCall:
                    this.eventType = this.$t("EventsTypesOptions.ScheduledCall");
                    break;
                case EventsTypes.RealtimeCall:
                    this.eventType = this.$t("EventsTypesOptions.RealtimeCall");
                    break;
                case EventsTypes.Notice:
                    this.eventType = this.$t("EventsTypesOptions.Notice");
                    break;
                case EventsTypes.Meal:
                    this.eventType = this.$t("EventsTypesOptions.Meal");
                    break;
            }
        },

        editRecurringOptionSelected(editRecurringEventType) {
            this.editRecurringEventType = editRecurringEventType;
            this.isOpenEditRecurringEventOptionsDialog = false;
            this.deleteRecurringEvents();
        },

        deleteRecurringEvents() {
            if (this.editRecurringEventType === EditRecurringEventTypes.SelectedEvent) {
                this.deleteSingleEvent();
            } else if (this.editRecurringEventType === EditRecurringEventTypes.CurrentAndfollowingEvents) {
                this.deleteCurrentAndFollowingEvents();
            } else {
                this.deleteAllRecurringEvents();
            }
        },


        async deleteCurrentAndFollowingEvents() {
            const [startDate, startTime] = this.selectedEvent.start.split(' ');
            const endDate = moment(this.calendarRecurringEvents[this.calendarRecurringEvents.length - 1].end).format('YYYY-MM-DD');

            this.$refs.confirmationModal
                .open(null, this.$i18n.messages[this.$i18n.locale]['ViewCalendarItem.DeleteCurrentAndFollowingsEventsMessage'], false)
                .then(async response => {
                    if (response && response.agree) {

                        await this.$store.dispatch('deleteCalenderEventSeriesByRange', {
                            parentEventId: this.selectedEvent?.parentEventId,
                            start: moment(startDate).startOf('date').toDate(),
                            end: moment(endDate).endOf('date').toDate()
                        })
                         .then(() => {
                            const start = moment(this.selectedEvent.startDate).add(-1, "month").toDate();
                            const end = moment(this.selectedEvent.endDate).add(1, "month").toDate();
                            this.$store.dispatch("getCalenderEvents", {start, end})
                         });
                    }
                })
        },

        async deleteAllRecurringEvents() {
            await this.$refs.confirmationModal
                .open(null, this.$i18n.messages[this.$i18n.locale]['ViewCalendarItem.DeleteEventSeriesMessage'], false)
                .then(async response => {
                    if (response && response.agree) {
                        await this.$store.dispatch('deleteCalenderEventSeries', {
                            parentEventId: this.selectedEvent?.parentEventId,
                            deleteUpcomingEvents: true
                        });
                    }
                });
        },


        closeRecurringOptionSelected() {
            this.readonly = true;
        },

        checkInvitedResidents() {
            this.loadingInvitedResidents = true
            this.invitedResidents = 0;

            if (this.selectedEvent.type === EventsTypes.LifestylePrograms) {

                if (this.facility.isOptInLifestylePrograms) {

                    if (this.selectedEvent.invitees[0] === "All") {
                        this.invitedResidents = this.$store.state.residentModule.residentsShortData.filter(x => x.status === ResidentStatus.ActiveResident).length;
                        this.loadingInvitedResidents = false

                        return false;
                    }

                    firebase
                        .firestore()
                        .collection("socialClubs")
                        .doc(this.selectedEvent.invitees[0])
                        .get()
                        .then((querySnapshot) => {
                            const program = querySnapshot.data();
                            this.invitedResidents = program.members.length
                            this.loadingInvitedResidents = false
                        }).catch(() => {
                        this.invitedResidents = 0
                        this.loadingInvitedResidents = false
                    })
                } else {
                    this.invitedResidents = this.$store.state.residentModule.residentsShortData.filter(x => x.status === ResidentStatus.ActiveResident).length;
                    this.loadingInvitedResidents = false
                }
            }

            if (this.selectedEvent.type === EventsTypes.PremiumServices) {
                firebase
                    .firestore()
                    .collection("additionalServices")
                    .doc(this.selectedEvent.invitees[0])
                    .get()
                    .then((querySnapshot) => {
                        const service = querySnapshot.data();
                        if (service.type === PremiumServiceEventTypes.ByAppointment) {
                            this.invitedResidents = this.selectedEvent.invitees?.length
                            this.loadingInvitedResidents = false
                        } else {
                            this.invitedResidents = service.membersIds?.length
                            this.loadingInvitedResidents = false
                        }
                    })
            }

            if (this.selectedEvent.type === EventsTypes.Notice) {
                this.invitedResidents = this.$store.state.residentModule.residentsShortData.length
                this.loadingInvitedResidents = false
            }

            if (this.selectedEvent.type === EventsTypes.ConciergeRequest) {
                this.invitedResidents = this.selectedEvent.attendees.length
                this.loadingInvitedResidents = false
            }

            if (this.selectedEvent.type === EventsTypes.ScheduledCall || this.selectedEvent.type === EventsTypes.RealtimeCall) {
                if (this.selectedEvent.createdByResidentId) {
                    if (this.selectedEvent.invitees) {
                        if (this.selectedEvent.invitees.find(x => x === this.selectedEvent.createdByResidentId)) {
                            this.invitedResidents = this.selectedEvent.invitees?.length
                            this.loadingInvitedResidents = false
                        } else {
                            this.invitedResidents = this.selectedEvent.invitees?.length + 1
                            this.loadingInvitedResidents = false
                        }
                    } else {
                        this.invitedResidents = 1
                        this.loadingInvitedResidents = false
                    }
                }
                if (this.selectedEvent.createdByStaffId || this.selectedEvent.createdByFamilyUserId) {
                    this.invitedResidents = 1
                    this.loadingInvitedResidents = false
                }
            }

            if (this.selectedEvent.type === EventsTypes.Meal) {
                this.invitedResidents = this.$store.state.residentModule.residentsShortData.filter(x => x.status === ResidentStatus.ActiveResident).length;
                this.loadingInvitedResidents = false
            }
        }
    },
    watch: {
        selectedOpen(value) {
            if (!value) {
                this.$emit('closeCalendarCard')
            }
        }
    }
}
